import { KeycloakService } from 'keycloak-angular';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KeycloakGuard } from './keycloak.guard';

import { environment } from '@wo-environments';

function KeycloakFactory(keycloak: KeycloakService): () => Promise<boolean> {
  return () => keycloak.init({
    config: environment.keycloak,
    initOptions: {
      checkLoginIframe: false,
    },
  }).catch((err) => {
    console.warn('Keycloak init failed:', err);
    return false;
  });
}

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    KeycloakService,
    KeycloakGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: KeycloakFactory,
      deps: [ KeycloakService ],
      multi: true,
    },
  ],
})
export class KeycloakAuthModule {}
